const DEFAULT_WIDTHS = [320, 640, 1024, 1280, 1920]

/**
 * Cleans URL by removing all existing query parameters
 * @param {string} url - The image URL
 * @returns {string} - Clean URL without parameters
 */
function cleanUrl(url) {
    try {
        const urlObj = new URL(url)
        return `${urlObj.origin}${urlObj.pathname}`
    } catch {
        // If URL parsing fails, try simple split on '?'
        return url.split('?')[0]
    }
}

/**
 * Generates srcset string with multiple widths
 * @param {string} baseUrl - The clean base URL
 * @param {number[]} widths - Array of widths to generate
 * @returns {string} - srcset string
 */
function generateSrcSet(baseUrl, widths) {
    return widths.map((width) => `${baseUrl}?width=${width} ${width}w`).join(', ')
}

export default function OptimizedImage({
    src,
    alt,
    sizes = '100vw',
    widths = DEFAULT_WIDTHS,
    className = '',
    loading = 'lazy',
    ...props
}) {
    if (!src) {
        return null
    }

    const cleanedUrl = cleanUrl(src)
    const srcSet = generateSrcSet(cleanedUrl, widths)
    // Use the middle width as default src fallback
    const defaultSrc = `${cleanedUrl}?width=${widths[Math.floor(widths.length / 2)]}`

    return (
        <img
            src={defaultSrc}
            srcSet={srcSet}
            sizes={sizes}
            alt={alt}
            loading={loading}
            className={className}
            {...props}
        />
    )
}
